/**
 * YouTube 占位播放框（snippets/youtube-video-frame.liquid）的交互
 *
 * 1. 未播放时 iframe 是 pointer-events: none，手指手势透给页面，
 *    所以在视频上滑动能正常滚动页面、也能横向拖动轮播；点播放才激活播放器。
 * 2. 播放中播放器会吞掉手势，页面又滚不动了。于是触屏设备播放时盖上 touch-guard：
 *    纵向滑动交给页面滚动（CSS touch-action: pan-y），横向滑动继续冒泡给轮播；
 *    点一下暂停，暂停后触摸层撤掉，YouTube 原生控件就能正常点（拖动进度、全屏）。
 */
(function () {
  // 同一页可能引入多次（多个视频 section），只绑一次，避免重复执行把视频重新加载
  if (window.__youtubeVideoFrameBound) return;
  window.__youtubeVideoFrameBound = true;

  // 给 YouTube iframe 发 API 消息
  function postMessage(iframe, payload) {
    if (!iframe || !iframe.contentWindow) return;
    iframe.contentWindow.postMessage(JSON.stringify(payload), '*');
  }

  function sendCommand(iframe, func) {
    postMessage(iframe, { event: 'command', func: func, args: '' });
  }

  // 订阅播放状态：只用来决定触摸层要不要出现（播放中才盖，暂停就让原生控件可点）
  var STATE_PLAYING = 1;
  var STATE_BUFFERING = 3;

  function syncPlayingState(source, state) {
    var iframes = document.querySelectorAll('.video_frame iframe');
    for (var i = 0; i < iframes.length; i++) {
      if (iframes[i].contentWindow !== source) continue;

      var frame = iframes[i].closest('.video_frame');
      if (frame) {
        // 1 = 播放中，3 = 缓冲中，都按播放处理
        frame.classList.toggle('is-playing', state === STATE_PLAYING || state === STATE_BUFFERING);
      }
      return;
    }
  }

  window.addEventListener('message', function (event) {
    var data = event.data;
    if (typeof data === 'string') {
      try {
        data = JSON.parse(data);
      } catch (e) {
        return;
      }
    }
    if (!data || !data.info) return;

    // infoDelivery 是轮询的完整状态，onStateChange 只在状态切换时来一次，两个都要收
    if (data.event === 'infoDelivery' && typeof data.info.playerState === 'number') {
      syncPlayingState(event.source, data.info.playerState);
    } else if (data.event === 'onStateChange' && typeof data.info === 'number') {
      syncPlayingState(event.source, data.info);
    }
  });

  document.addEventListener('click', function (event) {
    // 点播放按钮：激活播放器并自动播放
    var playButton = event.target.closest('.video_frame__play');
    if (playButton) {
      var frame = playButton.closest('.video_frame');
      if (!frame || frame.classList.contains('is-active')) return;

      var iframe = frame.querySelector('iframe');
      if (!iframe) return;

      // 激活后订阅播放状态，让触摸层随播放 / 暂停自动切换
      iframe.addEventListener('load', function () {
        postMessage(iframe, { event: 'listening' });
      });

      // 带上 autoplay 重新加载播放器；万一浏览器拦截了自动播放，用户再点一次触摸层即可播放
      var playSrc = playButton.getAttribute('data-video-src');
      if (playSrc) iframe.src = playSrc;

      frame.classList.add('is-active', 'is-playing');
      return;
    }

    // 点播放中的触摸层：暂停（暂停后触摸层撤掉，原生控件可用）
    var guard = event.target.closest('.video_frame__touch-guard');
    if (guard) {
      var guardFrame = guard.closest('.video_frame');
      if (!guardFrame) return;

      var playing = guardFrame.classList.contains('is-playing');
      sendCommand(guardFrame.querySelector('iframe'), playing ? 'pauseVideo' : 'playVideo');
      guardFrame.classList.toggle('is-playing', !playing);
    }
  });
})();
